import { DisposeSampleForm } from 'api/rack'
import { useDisposeSampleApi, usePostSampleApi } from 'api/sample'
import { Flex } from 'components/shared/flex'
import { InputField } from 'components/shared/input'
import { NestedModal } from 'components/shared/widget'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Sample, SampleForm } from 'entities/sample'
import { useContext, useState } from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useEffectSkipFirst, useForm } from 'utils/hooks'

type EditSampleFormProps = {
    onComplete?: (sample: Sample) => void
}

export const NewSampleForm = (props: EditSampleFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostSampleApi()
    const form = useForm<SampleForm>({})
    // const masterData = useContext(MasterDataContext)
    const [show, setShow] = useState<boolean>(false)

    const handleSubmit = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete(api.response)
                setShow(false)
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                ICA検体登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>ICA検体の登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="info">PJPatientID, CarifIDは自動生成されます</Alert>
                    <Flex>
                        <InputField apiError={api.apiError} form={form} attr="note" as="textarea" label="Note" />
                    </Flex>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleSubmit}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

type SampleDisposalModalProps = {
    sample: Sample
    show: boolean
    setShow: React.Dispatch<React.SetStateAction<boolean>>
    onDispose?: () => void
}

export const SampleDisposalModal = (props: SampleDisposalModalProps) => {
    const globalState = useContext(GlobalStateContext)
    const form = useForm<DisposeSampleForm>({})
    const api = useDisposeSampleApi()
    const handleClose = () => props.setShow(false)
    const handleSubmit = () => {
        api.execute(Number(props.sample.id), form)
    }
    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            props.setShow(false)
            props.onDispose && props.onDispose()
        }
    }, [api.loading])
    type ConfirmForm = { text?: string }
    const confirmForm = useForm<ConfirmForm>({})
    return (
        <>
            <NestedModal
                show={props.show}
                size="lg"
                onHide={() => {
                    confirmForm.set({})
                    props.setShow(false)
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>検体の廃棄</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="info">
                        <Flex flexDirection="column">
                            <div>廃棄日: {new Date().toLocaleDateString()}</div>
                            <div>廃棄する検体(検体コード): {props.sample.code}</div>
                        </Flex>
                    </Alert>
                    <Flex>
                        <InputField apiError={api.apiError} form={form} attr="disposalNote" as="textarea" label="メモ" />
                    </Flex>
                    <Flex flexDirection="column" style={{ marginTop: 20, width: '100%' }}>
                        <Alert variant="danger" style={{ width: '100%' }}>
                            この処理は取り消せません。廃棄を進める場合は、検体コードを入力してください。
                        </Alert>
                        <InputField form={confirmForm} attr="text" placeholder="検体コードを入力" />
                    </Flex>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button disabled={confirmForm.object.text !== props.sample.code} variant="danger" onClick={handleSubmit}>
                        廃棄
                    </Button>
                </Modal.Footer>
            </NestedModal>
        </>
    )
}
